/* eslint-disable import/no-extraneous-dependencies,no-param-reassign */
import { type PayloadAction, type Slice, createSlice } from "@reduxjs/toolkit"
import type { WritableDraft } from "immer"
import includes from "lodash-es/includes"
import reject from "lodash-es/reject"

enum EAppAnimationName {
    CoachingSessions_ScheduleBox = "CoachingSessions_ScheduleBox",
    CoachingSessions_LiveSession = "CoachingSessions_LiveSession",
    CoachingSessions_UpcomingSessions = "CoachingSessions_UpcomingSessions",
    CoachingSessions_PastSessions = "CoachingSessions_PastSessions",
    Diagnostic_Summary = "Diagnostic_Summary",
    Participant_CoachingSessions_Holds = "Participant_CoachingSessions_Holds",
    Participant_CoachingSessions_Coach = "Participant_CoachingSessions_Coach",
    Participant_Onboarding_DiagnosticStep_Likert = "Participant_Onboarding_DiagnosticStep_Likert",
    Participant_Onboarding_ReflectionStep_Responses = "Participant_Onboarding_ReflectionStep_Responses",
    Participant_Onboarding_CoachStep_Likert = "Participant_Onboarding_CoachStep_Likert",
    Participant_Onboarding_CoachStep_Coaches = "Participant_Onboarding_CoachStep_Coaches",
    Assistant_Participants_List = "Assistant_Participants_List"
}

const APP_REDUCER_NAME: string = "app"

interface IAppState {
    isOpenBurgerMenu: boolean
    isOpenSidebar: boolean
    appInit: boolean
    isVersionMismatched: boolean
    animations: EAppAnimationName[]
}

const initialState: IAppState = {
    isOpenBurgerMenu: false,
    isOpenSidebar: true,
    appInit: false,
    isVersionMismatched: false,
    animations: []
}

const slice: Slice = createSlice({
    name: APP_REDUCER_NAME,
    initialState,
    reducers: {
        toggleBurgerMenu(state: WritableDraft<IAppState>, action: PayloadAction<boolean>): void {
            state.isOpenBurgerMenu = action.payload || !state.isOpenBurgerMenu
        },
        toggleSidebar(state: WritableDraft<IAppState>): void {
            state.isOpenSidebar = !state.isOpenSidebar
        },
        openSidebar(state: WritableDraft<IAppState>): void {
            state.isOpenSidebar = true
        },
        closeSidebar(state: WritableDraft<IAppState>): void {
            state.isOpenSidebar = false
        },
        setAppInit(state: WritableDraft<IAppState>, action: PayloadAction<boolean>): void {
            state.appInit = action.payload
        },
        completeAnimation(state: WritableDraft<IAppState>, action: PayloadAction<EAppAnimationName>): void {
            if (!includes<EAppAnimationName>(state.animations, action.payload)) state.animations.push(action.payload)
        },
        resetAnimation(state: WritableDraft<IAppState>, action: PayloadAction<EAppAnimationName>): void {
            state.animations = reject<EAppAnimationName>(
                state.animations,
                (animation: EAppAnimationName): boolean => animation === action.payload
            )
        },
        setVersionMismatch(state: WritableDraft<IAppState>, action: PayloadAction<boolean>): void {
            state.isVersionMismatched = action.payload
        },
        clearAnimations(state: WritableDraft<IAppState>): void {
            state.animations = []
        },
        reset(_state: WritableDraft<IAppState>): IAppState {
            return initialState
        }
    }
})

const { reducer: appReducer, actions: appReducerActions }: Slice = slice

export { appReducer, appReducerActions, APP_REDUCER_NAME }
export { type IAppState }
export { EAppAnimationName }
